import {CssBaseline} from '@mui/material'
import React, {FC} from 'react'
import {hot, setConfig} from 'react-hot-loader'
import BrowserRouter from './@f_routeshere/browser_router'
import history from './@f_routeshere/history'
import Layout from './@g_layout'
import './locales'

setConfig({showReactDomPatchNotification: false})

const App: FC = function () {
  return (
    <React.StrictMode>
      <CssBaseline />
      <BrowserRouter history={history}>
        <Layout />
      </BrowserRouter>
    </React.StrictMode>
  )
}

declare let module: Record<string, unknown>

export default hot(module)(App)
